import { WithId } from '@common/typescript/objects/WithId';

import { VeterinarianCore } from '@app/objects/Veterinarian';

export interface OnlineBookingEntry {
	guid: string;
	lastStep: OnlineBookingLastStep;
	status: OnlineBookingStatus;
	createdAt: string;
	lastUpdatedAt: string;
	telehospiceOnly: boolean;
	zipCode: string;
	phoneNumber: string;
	phoneNumberConfirmed: true;
	firstName: string;
	lastName: string;
	email: string;
	addressLine1: string;
	addressLine2: string;
	city: string;
	stateObj: {
		id: number;
		name: string;
		code: string;
		daylightSaveTime: boolean;
		stateTimeOffset: number;
		tax: string;
		deleted: boolean;
	};
	state: string;
	zip: string;
	petName: string;
	petOwnerSource: string;
	sourceId: number;
	isExistingFamily: boolean;
	id: number;
	age: number;
	weight: number;
	gender: number;
	petNote: number;
	petTypeId: number;
	attitudeId: number;
	color: string;
	breed: string;
	clinicName: string;
	selectedAppointmentType: AppointmentParentType;
	selectedDate: number;
	selectedUser: VeterinarianCore;
	selectedUserId: number;
	expectedPrice: number;
	paymentInfoProvided: boolean;
	last4Digits: string,
	cardType: number,
	expirationMonth: number,
	expirationYear: number,
	authorizeOpaqueData: {
		dataDescriptor: string;
		dataValue: string;
	},
	aftercareType: CremationType,
	petPhoto: string;
	reason: OnlineBookingReason;
	moreAttitudeInfo: string;
	isAfterHours: boolean;
	drivingInstructions: string;
	familyMembers: string;
}

export interface OnlineBookingPet {
	id: number;
	name: string;
	petTypeName: string;
}

export enum OnlineBookingLastStep {
	Family,
	Pet,
	Appointment,
	Arrangements,
	Schedule,
	AdditionalInformation,
	Payment,
	Confirmation,
}

export enum OnlineBookingStatus {
	New,
	Partial,
	Finished,
}

export enum AppointmentParentType {
	Euthanasia = 0,
	Hospice = 1,
	BodyCarePickup = 2,
	Teleadvice = 3,
	Generic = 4,
}

export interface AppointmentType extends WithId {
	name: string;
	parentType: AppointmentParentType;
	onlineBookingDisplayName: string;
	onlineBookingDescription: string;
	hoverMessageColumn: string;
}

export interface ExistingOnlineBookingAppointmentResponse {
	petName: string;
	veterinarian: VeterinarianCore;
	appointmentDate: number;
	appointmentType: AppointmentType;
}

export enum CremationType {
	PrivateCremation = 0,
	CommunalCremation = 1,
	OwnerAftercare = 3,
}

export interface LiftingAssistanceResult {
	liftingAssistanceNeeded: boolean;
	minAssistance?: number;
	requiredAssistance?: number;
}

export enum SuggestiveBookingTime {
	Morning,
	Afternoon,
	Evening,
}

export enum OnlineBookingReason {
	None = 0,
	BookingBlocker = 1,
	NewFamilyRecord = 2,
	CrematoryAssistance = 4,
	AccountingFlag = 8,
	PetDisposition = 16,
	PaymentIssue = 32,
	SchedulingSupport = 64,
}

export interface SchedulePriceDetail {
	description: string;
	price: number;
}

export interface ScheduleOption {
	id: number;
	date: number;
	totalPrice: number;
	areaId: number;
	priceDetails: Array<SchedulePriceDetail>;
	veterinarian: VeterinarianCore;
}

export enum FamilyStep {
	FamilyCheckPhone,
	FamilyForm,
}

export enum StepPet {
	ChoosePet,
	FormPet,
}

export enum CardType {
	Visa = 0,
	MasterCard = 1,
	Amex = 2,
	Discover = 3,
	Other = 4,
}

export interface OwnerCard extends WithId {
	cardType: null | CardType;
	expirationMonth: number;
	expirationYear: number;
	last4Digits: number;
}
